/** MUI */
import makeStyles from "@mui/styles/makeStyles";

/** UI */
import Footer from "../_CommonLayout/Footer";
import Navbar from "../_CommonLayout/Navbar";

const useStyles = makeStyles((theme) => ({
    main: {
        marginTop: 106,
        paddingTop: theme.spacing(4),
        // paddingTop: theme.spacing(0),
        backgroundColor: "#FFF",
        [theme.breakpoints.up("md")]: {
            minHeight: "calc(100vh - 204px)",
        },
        [theme.breakpoints.down("sm")]: {
            marginTop: 74,
        },
    },
}));

const BazaDanychLayout = ({ children, fetched }) => {

    const classes = useStyles();

    return (
        <>
            <Navbar />
            <main className={classes.main}>{children}</main>
            <Footer fullWidth={true} hideLogos={false} />
        </>
    );
};

export default BazaDanychLayout;
